import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { useUpdateQuantityMutation } from "../../../../../store/newCart";
import { startLoading, stopLoading } from "../../../../../store/application";

import Icon from "../../../elements/icon";
import { PriceTier } from './pricingTier';
import Button from "../../../elements/button";
import { Modal, ModalHeader, ModalBody } from "../../../elements/Modal";

import { config } from '../../../../../utils/config';
import i18n from '../../../../../utils/translations/i18n';
import { sliderProductsPROD , sliderProductsNPR } from "./sliderProducts";
import { RootState } from "../../../../../store";
import { TierPricesObject } from "../../../../../models/tiers";
import { tierSelectGaEvent } from "../../../../shopping-bag/ga-module";
import { GaConstants } from "../../../../../enums/gaConstants";

declare const window: any;
export const SingleSelectQuantity = ({ cart, lineItemId, isOpen, toggleModal, showCustomQtySlider }) => {
  const { t } = i18n;
  const dispatch = useDispatch();
  const [updateSingleSelect] = useUpdateQuantityMutation();

  const mainItem: any = cart.lineItems[lineItemId][0].data;
  const getDataTierIndex = (tierObject, quantity) => {
    return tierObject.findIndex(tierData => parseInt(tierData?.quantity ?? 0) === quantity);
  }

  const { applicationState: { tierPricesData } } = useSelector((state: RootState) => state);

  const tierDataForMainItem: TierPricesObject = tierPricesData[mainItem?.productKey] || {};

  const [priceTierObject, setPriceTierObject] = useState<any[]>([]);
  const [oldPriceTierObject, setOldPriceTierObject] = useState<any[]>([]);
  const [selectedIndex, setSelectedIndex] = useState<number>(0);

  useEffect(() => {
    if (Object.keys(tierDataForMainItem).length > 0) {
      const { tierObject = [], oldPrices = [] } = tierDataForMainItem;
      const index = getDataTierIndex(tierObject, mainItem?.quantity);

      setPriceTierObject(tierObject);
      setOldPriceTierObject(oldPrices);
      setSelectedIndex(index);
    }
  }, [tierDataForMainItem, mainItem?.quantity]);

  const closeModal = () => {
    setSelectedIndex(getDataTierIndex(priceTierObject, mainItem?.quantity));
    toggleModal();
  }
  const filterPriceTiers = () => {
    let currentLocale = config('locale');
    const sliderProducts = window?.Config?.ENV_NAME === "prd" ? sliderProductsPROD : sliderProductsNPR;
    for(let i = 0 ; i < sliderProducts?.length ; i++){
      let currentProduct = sliderProducts[i];
      if(currentProduct?.productKey?.toLowerCase() === mainItem?.productKey?.toLowerCase() && currentLocale === currentProduct?.locale){
          let visiblePriceTiers = currentProduct?.priceTiers;
          let filteredPriceTiersObject  = priceTierObject?.filter(function(priceTier){
              for(let j = 0 ; j < visiblePriceTiers?.length ; j++) {
                  if(visiblePriceTiers[j] === priceTier['quantity']) return true;
              }
              return false;
          })
          let filteredOldPriceTiersObject = oldPriceTierObject?.filter(function(priceTier){
              for(let j = 0 ; j < visiblePriceTiers?.length ; j++) {
                if(visiblePriceTiers[j] === priceTier['quantity']) return true;
              }
              return false;
          })
          setPriceTierObject(filteredPriceTiersObject);
          setOldPriceTierObject(filteredOldPriceTiersObject)
          break;
      }
    }
  }

  useEffect(() => {
    if(priceTierObject.length > 0 && oldPriceTierObject.length > 0) filterPriceTiers();
  },[priceTierObject.length, oldPriceTierObject.length])

  useEffect(() => {
    setSelectedIndex(getDataTierIndex(priceTierObject, mainItem?.quantity));
  },[priceTierObject])

  const saveAndUpdateCart = async () => {
    tierSelectGaEvent(priceTierObject[selectedIndex], selectedIndex, false, mainItem, GaConstants.TABLE, cart?.fractionDigits);
    if (mainItem.quantity !== Number(priceTierObject?.[selectedIndex]?.quantity)) {
      dispatch(startLoading());
      updateSingleSelect({
        cartId: cart.id,
        lineItems: {
          "data": {
            "type": "mainItem",
            "attributes": {
              "lineItemId": mainItem.id,
              "quantity": Number(priceTierObject?.[selectedIndex]?.quantity ?? 0)
            }
          }
        }
      })
    } else {
      dispatch(stopLoading());
    }
    toggleModal();
  }

  const editHeader = <>
    <ModalHeader>
      <>
        <h3 className="mega">{t('product_details.edit_number_of_units')}</h3>
      </>
    </ModalHeader>
  </>;

  const editBody = <ModalBody>
    <>
      <PriceTier
        tierPricesData={tierDataForMainItem}
        priceTierObject={priceTierObject}
        oldPriceTierObject={oldPriceTierObject}
        isShoppingFeed={"false"}
        selectedIndex={selectedIndex}
        setSelectedIndex={(selectedIndex) => setSelectedIndex(selectedIndex)}
        mainItem={mainItem}
        showCustomQtySlider={showCustomQtySlider}
      />
      {config('isNASite') !== true && <>
        <div className="summary-total">
          <span className="bold">{t('product_details.price_excl_vat')}</span>
          <span className="summary-total__price">
            <span id="excluding-vat-price" className="summary-total-amount">
              {priceTierObject?.[selectedIndex]?.subtotal ?? 0}
            </span>
          </span>
        </div>
        <div className="summary-total summary-total--excl-vat below-24">
          <span className="summary-brand-color bold">{t('product_details.price_incl_vat')}</span>
          <span className="summary-total__price">
            <span id="including-vat-price" className="summary-total-amount">
              {priceTierObject?.[selectedIndex]?.incTaxValueWithCurrency}
            </span>
          </span>
        </div></>}

      {config('isNASite') === true && <>
        <div className="summary-total">
          <span className="bold">{t('product_details.price')}</span>
          <span className="summary-total__price">
            <span id="excluding-vat-price" className="summary-total-amount">
              {priceTierObject?.[selectedIndex]?.subtotal ?? 0}
            </span>
          </span>
        </div>
      </>}

    </>
  </ModalBody>

  const editFooter = <>
    <Button className="save-add-cart btn btn--large btn--full-width btn--pill" onClick={saveAndUpdateCart} children={t('shopping_cart_details.saveAndUpdate')} style={{ textTransform:'none'}} />
    <div className="error-edit-qty"> {t('shopping_cart_details.changeQtyError')}</div>
  </>

  return (
    <>
      <Modal
        isOpen={isOpen}
        onClose={closeModal}
        extraStyles={{display:"block"}}
        className="single-qty"
      >
        <>
          <div className='modal-close' >
            {<Icon icon="Close(Esc)" className="icon-cancel" onClick={closeModal} />}
          </div>
          {editHeader}
          {editBody}
          {editFooter}
        </>
      </Modal>
    </>
  );
};
